import { useSessionData } from 'src/hook/useSessionData'
import { RiPencilFill } from '@remixicon/react'
import { useUserProfile } from 'src/components/globalUserProfile'
import { useGetUserData } from '../../hooks'
import { UserInfoSkeleton } from '../userInfoSkeleton'
import { UserInfoErrorState } from '../userInfoErrorState'
import { Avatar, AvatarWrapper, UserName, EditButton, Wrapper } from './userInfo.styles'
import { AVATAR_DIMENSIONS } from './userInfo.constants'

const UserInfo = () => {
  const { user } = useSessionData()
  const { visible, userUcode = user?.ucode, isSessionUserProfile } = useUserProfile()
  const { isLoading, isError, data } = useGetUserData({
    ucode: userUcode,
    avatarDimensions: AVATAR_DIMENSIONS,
    enabled: visible
  })

  const handleRedirectToMyAccount = () => {
    window.open(`${process.env.MY_ACCOUNT_URL}?systemOrigin=club-new`, '_blank')
  }

  if (isLoading) {
    return (
      <Wrapper className="_border-bottom _border-gray-200">
        <UserInfoSkeleton />
      </Wrapper>
    )
  }

  if (isError) {
    return (
      <Wrapper className="_border-bottom _border-gray-200">
        <UserInfoErrorState />
      </Wrapper>
    )
  }

  return (
    <Wrapper className="_border-bottom _border-gray-200 _px-5 _pb-5">
      <div className="_d-flex _align-items-center">
        <AvatarWrapper className="_d-flex _align-items-center _flex-grow-0 _flex-shrink-0 _rounded-circle _overflow-hidden _mr-4">
          <Avatar src={data?.avatarUrl} alt={data?.name} className="_w-full _h-full" />
        </AvatarWrapper>

        <div className="_d-flex _flex-column">
          <UserName className="_text-gray-900 _font-weight-bold">{data?.name}</UserName>
          {data?.username && (
            <div className="_d-flex _align-items-center">
              <div className="_text-gray-500 _font-14 _align-items-center _d-flex _mt-1">
                @{data?.username}
              </div>
              {isSessionUserProfile && (
                <EditButton
                  className="_align-items-center _d-flex _ml-1 _font-14 _text-blue-dark _border-0"
                  onClick={handleRedirectToMyAccount}
                  aria-label="edit-username"
                >
                  <RiPencilFill />
                </EditButton>
              )}
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  )
}

export default UserInfo
